import Vue from 'vue'
import App from './App.vue'

import vuetify from './plugins/vuetify'
import './plugins/clipboard'
import './plugins/sse' // server sent events (notifications)
import './plugins/localstorage'
import './plugins/charts'
import './filters/filters' // global filter

import http   from './http'
import store from './store/index'
import router from './router/index'
import config from './config'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

new Vue({
  vuetify,
  http: http,
  store: store,
  router: router,
  config: config,
  render: h => h(App)
}).$mount('#app')
